// pack-odds.js
// Retail packet model + Numbered Parallels (1:14 packs)

window.ODDS = {
  // Pack composition
  cardsPerPack: 10,
  baseCountMin: 6,
  baseCountMax: 7,
  commonInsertsPerPack: 2,
  uncommonInsertsPerPack: 1,

  // Rare/special hits (pack-level)
  specials: {
    chromeKing:    { p: 1/10,   label: 'Chrome King',    oddsText: '1 in 10 packs' },
    goldLion:      { p: 1/28,   label: 'Gold Lion',      oddsText: '1 in 28 packs' },
    premierPull:   { p: 1/100,  label: 'Premier Pull',   oddsText: '1 in 100 packs' },
    diamondRookie: { p: 1/500,  label: 'Diamond Rookie', oddsText: '1 in 500 packs' },
    autograph:     { p: 1/168,  label: 'Autograph',      oddsText: '1 in 168 packs' },
    // NEW: numbered parallel hit (applied by upgrading an eligible card in the pack)
    numberedParallel: { p: 1/14, label: 'Numbered Parallel', oddsText: '1 in 14 packs' }
  },

  // Retail base parallels (non-numbered, at most one per pack)
  baseParallels: [
    { name: 'Blue',   p: 1/2,  oddsText: '1 in 2 packs' },
    { name: 'Yellow', p: 1/4,  oddsText: '1 in 4 packs' },
    { name: 'Green',  p: 1/8,  oddsText: '1 in 8 packs' }
  ],

  // Labels for rendering
  labels: {
    base:     { label: 'Base',           oddsText: '6–7 per pack' },
    common:   { label: 'Common Insert',  oddsText: '2 per pack' },
    uncommon: { label: 'Uncommon Insert',oddsText: '1 per pack' }
  },

  // Checklist buckets used by the simulator
  buckets: {
    // 2-per-pack common inserts
    common: [
      'generationNow', 'retroThreads', 'proPartnerships', 'fullForce', 'tekkers'
      // If/when you want Breakthrough Ballers as a common insert, add: 'breakthroughBallers'
    ],
    // 1-per-pack uncommon insert
    uncommon: ['beastMode','proPrecision','headliners'],

    // Rare/special sets for their own hits
    chromeKing:     'chromeKings',
    goldLion:       'goldLions',
    premierPull:    'premierPull',
    diamondRookie:  'diamondRookies',

    // Pools for standalone autos when an autograph hits and can’t upgrade an in-pack card
    autographEligible: {
      beastModeAuto:   'beastModeAuto',
      chromeKingsAuto: 'chromeKingsAuto',
      blackEdgeAutos:  'blackEdgeAutos',
      baseAutos:       'baseAutos'
    }
  },

  // NEW: Numbered parallel tiers per set.
  // When a numbered parallel triggers, we pick a card in the pack from one of these sets
  // and upgrade it using these tiers (weighted by print run "run").
  numbered: {
    tiers: {
      // Base numbered cards
      base: [
        { name: 'Mini Diamond - Agua',          short: 'Agua',  run: 499 },
        { name: 'Mini Diamond - Pink',          short: 'Pink',  run: 399 },
        { name: 'Mini Diamond - Yellow',        short: 'Yellow',run: 299 },
        { name: 'Mini Diamond - Purple',        short: 'Purple',run: 199 },
        { name: 'Mini Diamond - Blue',          short: 'Blue',  run: 150 },
        { name: 'Mini Diamond - Green',         short: 'Green', run: 99  },
        { name: 'Mini Diamond - Black & White', short: 'B&W',   run: 75  },
        { name: 'Mini Diamond - Gold',          short: 'Gold',  run: 50  },
        { name: 'Mini Diamond - Orange',        short: 'Orange',run: 25  },
        { name: 'Mini Diamond - Black',         short: 'Black', run: 10  },
        { name: 'Mini Diamond - Red',           short: 'Red',   run: 5   },
        { name: 'Mini Diamond - Platinum',      short: 'Platinum', run: 1 }
      ],

      // Common inserts
      generationNow: [
        { name: 'Mini Diamond - Yellow', short:'Yellow', run:299 },
        { name: 'Mini Diamond - Purple', short:'Purple', run:199 },
        { name: 'Mini Diamond - Blue',   short:'Blue',   run:150 },
        { name: 'Mini Diamond - Green',  short:'Green',  run:99  },
        { name: 'Mini Diamond - B&W',    short:'B&W',    run:75  },
        { name: 'Mini Diamond - Gold',   short:'Gold',   run:50  },
        { name: 'Mini Diamond - Orange', short:'Orange', run:25  },
        { name: 'Mini Diamond - Black',  short:'Black',  run:10  },
        { name: 'Mini Diamond - Red',    short:'Red',    run:5   },
        { name: 'Mini Diamond - Platinum', short:'Platinum', run:1 }
      ],
      retroThreads: [
        { name:'Mini Diamond - Yellow', short:'Yellow', run:299 },
        { name:'Mini Diamond - Purple', short:'Purple', run:199 },
        { name:'Mini Diamond - Blue',   short:'Blue',   run:150 },
        { name:'Mini Diamond - Green',  short:'Green',  run:99  },
        { name:'Mini Diamond - B&W',    short:'B&W',    run:75  },
        { name:'Mini Diamond - Gold',   short:'Gold',   run:50  },
        { name:'Mini Diamond - Orange', short:'Orange', run:25  },
        { name:'Mini Diamond - Black',  short:'Black',  run:10  },
        { name:'Mini Diamond - Red',    short:'Red',    run:5   },
        { name:'Mini Diamond - Platinum', short:'Platinum', run:1 }
      ],
      proPartnerships: [
        { name:'Mini Diamond - Yellow', short:'Yellow', run:299 },
        { name:'Mini Diamond - Purple', short:'Purple', run:199 },
        { name:'Mini Diamond - Blue',   short:'Blue',   run:150 },
        { name:'Mini Diamond - Green',  short:'Green',  run:99  },
        { name:'Mini Diamond - B&W',    short:'B&W',    run:75  },
        { name:'Mini Diamond - Gold',   short:'Gold',   run:50  },
        { name:'Mini Diamond - Orange', short:'Orange', run:25  },
        { name:'Mini Diamond - Black',  short:'Black',  run:10  },
        { name:'Mini Diamond - Red',    short:'Red',    run:5   },
        { name:'Mini Diamond - Platinum', short:'Platinum', run:1 }
      ],
      fullForce: [
        { name:'Mini Diamond - Yellow', short:'Yellow', run:299 },
        { name:'Mini Diamond - Purple', short:'Purple', run:199 },
        { name:'Mini Diamond - Blue',   short:'Blue',   run:150 },
        { name:'Mini Diamond - Green',  short:'Green',  run:99  },
        { name:'Mini Diamond - B&W',    short:'B&W',    run:75  },
        { name:'Mini Diamond - Gold',   short:'Gold',   run:50  },
        { name:'Mini Diamond - Orange', short:'Orange', run:25  },
        { name:'Mini Diamond - Black',  short:'Black',  run:10  },
        { name:'Mini Diamond - Red',    short:'Red',    run:5   },
        { name:'Mini Diamond - Platinum', short:'Platinum', run:1 }
      ],
      tekkers: [
        { name:'Mini Diamond - Yellow', short:'Yellow', run:299 },
        { name:'Mini Diamond - Purple', short:'Purple', run:199 },
        { name:'Mini Diamond - Blue',   short:'Blue',   run:150 },
        { name:'Mini Diamond - Green',  short:'Green',  run:99  },
        { name:'Mini Diamond - B&W',    short:'B&W',    run:75  },
        { name:'Mini Diamond - Gold',   short:'Gold',   run:50  },
        { name:'Mini Diamond - Orange', short:'Orange', run:25  },
        { name:'Mini Diamond - Black',  short:'Black',  run:10  },
        { name:'Mini Diamond - Red',    short:'Red',    run:5   },
        { name:'Mini Diamond - Platinum', short:'Platinum', run:1 }
      ],

      // Uncommon inserts (lower tiers only)
      proPrecision: [
        { name:'Mini Diamond - B&W',  short:'B&W',  run:75 },
        { name:'Mini Diamond - Gold', short:'Gold', run:50 },
        { name:'Mini Diamond - Orange', short:'Orange', run:25 },
        { name:'Mini Diamond - Black', short:'Black', run:10 },
        { name:'Mini Diamond - Red',   short:'Red',   run:5  },
        { name:'Mini Diamond - Platinum', short:'Platinum', run:1 }
      ],
      beastMode: [
        { name:'Mini Diamond - B&W',  short:'B&W',  run:75 },
        { name:'Mini Diamond - Gold', short:'Gold', run:50 },
        { name:'Mini Diamond - Orange', short:'Orange', run:25 },
        { name:'Mini Diamond - Black', short:'Black', run:10 },
        { name:'Mini Diamond - Red',   short:'Red',   run:5  },
        { name:'Mini Diamond - Platinum', short:'Platinum', run:1 }
      ],
      headliners: [
        { name:'Mini Diamond - B&W',  short:'B&W',  run:75 },
        { name:'Mini Diamond - Gold', short:'Gold', run:50 },
        { name:'Mini Diamond - Orange', short:'Orange', run:25 },
        { name:'Mini Diamond - Black', short:'Black', run:10 },
        { name:'Mini Diamond - Red',   short:'Red',   run:5  },
        { name:'Mini Diamond - Platinum', short:'Platinum', run:1 }
      ],

      // Chrome Kings refractors
      chromeKings: [
        { name:'Gold Refractor',   short:'Gold Ref.',  run:50 },
        { name:'Orange Refractor', short:'Orange Ref.',run:25 },
        { name:'Black Refractor',  short:'Black Ref.', run:10 },
        { name:'Red Refractor',    short:'Red Ref.',   run:5  },
        { name:'SuperFractor',     short:'SuperFractor', run:1 }
      ],

      // Diamond Rookie
      diamondRookies: [
        { name:'Diamond',       short:'Diamond', run:25 },
        { name:'Black Diamond', short:'Black Diamond', run:10 },
        { name:'Ruby',          short:'Ruby',    run:5  }
      ],

      // Autographs (applies to any autograph card in-pack)
      autographs: [
        { name:'Mini Diamond - Blue',   short:'Blue',   run:150 },
        { name:'Mini Diamond - Green',  short:'Green',  run:99  },
        { name:'Mini Diamond - B&W',    short:'B&W',    run:75  },
        { name:'Mini Diamond - Gold',   short:'Gold',   run:50  },
        { name:'Mini Diamond - Orange', short:'Orange', run:25  },
        { name:'Mini Diamond - Black',  short:'Black',  run:10  },
        { name:'Mini Diamond - Red',    short:'Red',    run:5   },
        { name:'Mini Diamond - Platinum', short:'Platinum', run:1 }
      ]
    }
  }
};
